var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"left","padding":"20px","max-width":"800px","margin":"0 auto"},attrs:{"id":"detail"}},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('img',{attrs:{"src":_vm.image}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }